import React, { useEffect, useState } from "react"
import { SelectOption } from "../../state/helpers/SelectOption"
import { injectIntl, FormattedMessage } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import LabelService from "../../state/label/LabelService"
import { TYPE_CUSTOMER_TAG } from "../../state/label/labelTypes"
import Label from "../../state/label/Label"
import InlineMultiSelectComponent from "../../common/inline-edit/component/InlineMultiSelectComponent"
import { GlobalHelper } from "../../indexImports"


type OwnProps = {
    customerTags: string[]
    onCustomerTagsChange: (string, actionId) => void
}
const CustomerTagSelectComponent = (props: OwnProps & IntlProps) => {
    const [labels, setLabels] = useState<Label[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)

    useEffect(() => {
        (async () => {
            const labels = await LabelService.getLabelsOf(TYPE_CUSTOMER_TAG)
            setLabels(labels as Label[])
            setIsLoading(false)
        })()
    }, [])

    const options = [...createOptions(labels)]
    const selectedOptions = options.filter(x => props.customerTags.includes(x.value as string))
    return (
        <>
            <label className="col-12 col-form-label custom-form-label">
                {GlobalHelper.hasGolfIntegration() ?
                    <FormattedMessage
                        id="price_list.edit.details.player_tags_label"
                        defaultMessage="Player types allowed to register"
                    /> :
                    <FormattedMessage
                        id="price_list.edit.details.customer_tags_label"
                        defaultMessage="Customer must have at least one of these tags"
                    />
                }
            </label>

            <div className="col-12">
                {!isLoading &&
                    <InlineMultiSelectComponent
                        title={selectedOptions.map(o => o.label).join(", ")}
                        name="price-list-customer-tag-select"
                        id="price-list-customer-tag-select"
                        value={selectedOptions}
                        onChange={(option, actionId) => {
                            props.onCustomerTagsChange(option.map(o => o.value), actionId)
                        }}
                        options={options}
                    />
                }
            </div>
        </>
    )
}

function createOptions(customerTypes: Label[]): SelectOption[] {
    return customerTypes.map(l => ({ label: l.getTitle(), value: l.getTitle() }))
}

export default injectIntl(CustomerTagSelectComponent)


// WEBPACK FOOTER //
// ./src/price-list/components/CustomerTagSelectComponent.tsx